import React from "react";

interface LayoutPrintProps {
    children?: React.ReactNode;
    className?: string;
    disableRightClick?: boolean;
}

export const LayoutPrint: React.FC<LayoutPrintProps> = ({children, className = "", disableRightClick = false}: LayoutPrintProps) => {

    const handleClick = (event: React.MouseEvent) => {
        if (disableRightClick) {
            event.preventDefault();
            alert("Use the provided Print button at the bottom of the page.");
        }
    };
    return <>
        <div className={`contextMenu`} onContextMenu={handleClick}>
        </div>
        <div className={`printPage ${className}`}>
            <main>
                {children}
            </main>
        </div>
    </>;
};
